/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'shining',
    quality: 0.5,
    perception: 2,
    mana: 1,
    willpower: 2
}